// Configuración comercial real. Completar con los datos del checkout antes de publicar.
export const offer = {
  checkoutUrl: 'https://megapack-antipantallas.impultienda.ar',
  extrasCheckoutUrl: '#comprar-extras',
  // Precio mostrado tal como lo devuelve el checkout (ej. "$ 9.900 ARS"). null = se muestra en el checkout.
  price: null as string | null,
  extrasPrice: null as string | null,
  extrasName: 'Recursos adicionales',
  // Fecha ISO real de finalización de la promoción. null = sin contador.
  countdownEndsAt: null as string | null,
  // Si no hay fecha fija: duración de la promoción desde la primera visita (se conserva al recargar).
  countdownMinutes: 60 as number | null,
  refundPolicyUrl: null as string | null,
  email: 'soporte.readykitdigital@gmail.com',
  domain: 'www.readykitdigital.com',
  socials: [] as { label: string; url: string }[],
  mockupImage:
    'https://cdn.magicpatterns.com/uploads/fZAxXQLJoV3SnbWZEJyEZz/Mockup_Antipantallas.png',
};
